import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=e5d36d6a&scoped=true"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=e5d36d6a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d36d6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5d36d6a')) {
      api.createRecord('e5d36d6a', component.options)
    } else {
      api.reload('e5d36d6a', component.options)
    }
    module.hot.accept("./IconButton.vue?vue&type=template&id=e5d36d6a&scoped=true", function () {
      api.rerender('e5d36d6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ds/IconButton.vue"
export default component.exports